module.exports = __webpack_public_path__ + "static/media/arrow-down-white.757f0d10.svg";